import { render } from "./order-status-component.vue?vue&type=template&id=767023c2&scoped=true"
import script from "./order-status-component.vue?vue&type=script&lang=js"
export * from "./order-status-component.vue?vue&type=script&lang=js"

import "./order-status-component.vue?vue&type=style&index=0&id=767023c2&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767023c2"]])

export default __exports__